// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1a4po","option":"styles_option__3vtzo","active":"styles_active__1NCeL"};